export default {
  pt: {
    'shipments.rascunho.botao': 'Rascunho de cargas',
    'shipments.rascunho.contrato': 'Contrato',
    'shipments.rascunho.data': 'Data',
    'shipments.rascunho.quantidade': 'Quantidade de cargas',
    'shipments.rascunho.carga': 'Carga',
    'shipments.rascunho.linha': 'Carga {{numero}}',
    'shipments.rascunho.motorista': 'Motorista',
    'shipments.rascunho.cavalo': 'Placa Cavalo',
    'shipments.rascunho.carreta': 'Carreta',
    'shipments.rascunho.instrucao': 'Escolha pelo motorista, cavalo ou carreta para preencher o conjunto. Todos os status do seu Painel de Descarga estão disponíveis.',
    'shipments.rascunho.temporario': 'Os dados são descartados ao fechar.',
    'shipments.rascunho.vazio': 'Informe a quantidade de cargas para começar.',
    'shipments.rascunho.semConjuntos': 'Nenhum conjunto no seu Painel de Descarga.',
    'shipments.rascunho.naoInformado': 'Não informado',
    'shipments.rascunho.aDefinir': 'A definir',
    'shipments.rascunho.limite': 'Informe de 1 a {{max}} cargas.',
    'shipments.rascunho.tituloMensagem': 'RASCUNHO DE CARGAS',
    'shipments.rascunho.copiado': 'Mensagem copiada.',
    'shipments.rascunho.erroCopiar': 'Não foi possível copiar a mensagem. Tente novamente.',
    'shipments.rascunho.excel': 'Baixar Excel',
    'shipments.rascunho.copiar': 'Copiar mensagem',
    'shipments.rascunho.copiarImagem': 'Copiar imagem',
    'shipments.rascunho.baixarImagem': 'Baixar PNG',
    'shipments.rascunho.imagemCopiada': 'Imagem copiada.',
    'shipments.rascunho.erroImagem': 'Não foi possível gerar ou copiar a imagem. Tente novamente.',
    'shipments.rascunho.imagemNaoSuportada': 'Este navegador não permite copiar imagens. Use Baixar PNG.',
  },
  en: {
    'shipments.rascunho.botao': 'Load draft',
    'shipments.rascunho.contrato': 'Contract',
    'shipments.rascunho.data': 'Date',
    'shipments.rascunho.quantidade': 'Number of loads',
    'shipments.rascunho.carga': 'Load',
    'shipments.rascunho.linha': 'Load {{numero}}',
    'shipments.rascunho.motorista': 'Driver',
    'shipments.rascunho.cavalo': 'Truck plate',
    'shipments.rascunho.carreta': 'Trailer',
    'shipments.rascunho.instrucao': 'Choose a driver, truck or trailer to fill in the combination. All statuses from your Unloading Board are available.',
    'shipments.rascunho.temporario': 'The draft is discarded when you close this screen.',
    'shipments.rascunho.vazio': 'Enter the number of loads to begin.',
    'shipments.rascunho.semConjuntos': 'No combinations on your Unloading Board.',
    'shipments.rascunho.naoInformado': 'Not provided',
    'shipments.rascunho.aDefinir': 'To be defined',
    'shipments.rascunho.limite': 'Enter between 1 and {{max}} loads.',
    'shipments.rascunho.tituloMensagem': 'LOAD DRAFT',
    'shipments.rascunho.copiado': 'Message copied.',
    'shipments.rascunho.erroCopiar': 'Could not copy the message. Try again.',
    'shipments.rascunho.excel': 'Download Excel',
    'shipments.rascunho.copiar': 'Copy message',
    'shipments.rascunho.copiarImagem': 'Copy image',
    'shipments.rascunho.baixarImagem': 'Download PNG',
    'shipments.rascunho.imagemCopiada': 'Image copied.',
    'shipments.rascunho.erroImagem': 'Could not generate or copy the image. Try again.',
    'shipments.rascunho.imagemNaoSuportada': 'This browser cannot copy images. Use Download PNG.',
  },
  es: {
    'shipments.rascunho.botao': 'Borrador de cargas',
    'shipments.rascunho.contrato': 'Contrato',
    'shipments.rascunho.data': 'Fecha',
    'shipments.rascunho.quantidade': 'Cantidad de cargas',
    'shipments.rascunho.carga': 'Carga',
    'shipments.rascunho.linha': 'Carga {{numero}}',
    'shipments.rascunho.motorista': 'Conductor',
    'shipments.rascunho.cavalo': 'Placa del tractor',
    'shipments.rascunho.carreta': 'Remolque',
    'shipments.rascunho.instrucao': 'Elija por conductor, tractor o remolque para completar el conjunto. Están disponibles todos los estados de su Panel de Descarga.',
    'shipments.rascunho.temporario': 'Los datos se descartan al cerrar.',
    'shipments.rascunho.vazio': 'Indique la cantidad de cargas para comenzar.',
    'shipments.rascunho.semConjuntos': 'No hay conjuntos en su Panel de Descarga.',
    'shipments.rascunho.naoInformado': 'No informado',
    'shipments.rascunho.aDefinir': 'Por definir',
    'shipments.rascunho.limite': 'Indique de 1 a {{max}} cargas.',
    'shipments.rascunho.tituloMensagem': 'BORRADOR DE CARGAS',
    'shipments.rascunho.copiado': 'Mensaje copiado.',
    'shipments.rascunho.erroCopiar': 'No se pudo copiar el mensaje. Inténtelo de nuevo.',
    'shipments.rascunho.excel': 'Descargar Excel',
    'shipments.rascunho.copiar': 'Copiar mensaje',
    'shipments.rascunho.copiarImagem': 'Copiar imagen',
    'shipments.rascunho.baixarImagem': 'Descargar PNG',
    'shipments.rascunho.imagemCopiada': 'Imagen copiada.',
    'shipments.rascunho.erroImagem': 'No se pudo generar o copiar la imagen. Inténtelo de nuevo.',
    'shipments.rascunho.imagemNaoSuportada': 'Este navegador no permite copiar imágenes. Use Descargar PNG.',
  },
}
